import { render, staticRenderFns } from "./courseName.vue?vue&type=template&id=3431a48c&scoped=true&"
import script from "./courseName.vue?vue&type=script&lang=js&"
export * from "./courseName.vue?vue&type=script&lang=js&"
import style0 from "./courseName.vue?vue&type=style&index=0&id=3431a48c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3431a48c",
  null
  
)

export default component.exports